import { EnvironmentVariables } from "./env";
import EnvContext from "./env-context";

const EnvProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const env: EnvironmentVariables = {
    dev: import.meta.env.DEV,
    appEnv: import.meta.env.VITE_APP_ENV,
    apiUrl: import.meta.env.VITE_API_URL,
    pylonAppId: import.meta.env.VITE_PYLON_APP_ID,
    posthogPublicKey: import.meta.env.VITE_POSTHOG_PUBLIC_KEY,
    posthogPublicHost: import.meta.env.VITE_POSTHOG_PUBLIC_HOST,
    sentryDsn: import.meta.env.VITE_SENTRY_DSN,
    serviceTitanBaseUrl: import.meta.env.VITE_SERVICE_TITAN_BASE_URL,
  };

  return <EnvContext.Provider value={env}>{children}</EnvContext.Provider>;
};

export default EnvProvider;
